export const COMMUNITY_LISTINGS_TARGET = 'community-listings'
export const COMMUNITY_DETAIL_TARGET = 'community-detail'
